import { createTheme } from '@mui/material/styles';

const customTheme  = createTheme({
    typography: {
      fontFamily: ['"Montserrat"', 'Open Sans'].join(','),
      h1: {
        fontFamily: '"Montserrat", Open Sans',
        fontSize: 22 + 'px',
        fontWeight: 'bold',
        color: '#202224',
      }
    },
    components: {
      MuiButton: {
        styleOverrides: {
          outlined: {
            backgroundColor: "green"
          }
        }
      },
      MuiCssBaseline: {
        styleOverrides: {
          body: {
            scrollbarColor: "#6b6b6b #2b2b2b",
            "&::-webkit-scrollbar, & *::-webkit-scrollbar": {
              backgroundColor: "#2b2b2b",
            },
            "&::-webkit-scrollbar-thumb, & *::-webkit-scrollbar-thumb": {
              borderRadius: 8,
              backgroundColor: "#6b6b6b",
              minHeight: 24,
              border: "3px solid #2b2b2b",
            },
            "&::-webkit-scrollbar-thumb:focus, & *::-webkit-scrollbar-thumb:focus": {
              backgroundColor: "#959595",
            },
            "&::-webkit-scrollbar-thumb:active, & *::-webkit-scrollbar-thumb:active": {
              backgroundColor: "#959595",
            },
            "&::-webkit-scrollbar-thumb:hover, & *::-webkit-scrollbar-thumb:hover": {
              backgroundColor: "#959595",
            },
            "&::-webkit-scrollbar-corner, & *::-webkit-scrollbar-corner": {
              backgroundColor: "#2b2b2b",
            },
          }
        }
      }
    }
})
  

export default customTheme ;